import React from "react";
import { ModuleConfig } from "../../types/ModuleConfig";

const tomModuleConfig: ModuleConfig = {
  id: "tom",
  name: "Tom AI Assistant",
  description: "AI-powered business automation assistant",
  version: "1.0.0",
  enabled: true,
  category: "intelligence",
  order: 99,
  icon: "FiZap",
  color: "#9F7AEA",

  routes: [],

  navigation: [],

  permissions: {
    view: [],
    create: [],
    edit: [],
    delete: [],
  },
};

export default tomModuleConfig;
